export default "__VITE_ASSET__DlBUJAUL__"